/* @flow */

import Company from 'models/companies/company';
import RegisterReferralRequest from 'models/requests/sellers/registerReferralRequest';
import IncompleteAlertRequest from 'models/requests/register/incompleteAlertRequest';

export default class RegisterReferralForm {
  company: Company;
  lastName: string;
  firstName: string;
  email: string;
  phone: string;
  mobilePresence: string;
  languageId: number;

  constructor() {
    this.company = null;
    this.lastName = '';
    this.firstName = '';
    this.email = '';
    this.phone = '';
    this.mobilePresence = '';
    this.languageId = 0;
  }

  toRequest(companyId: number){
    const request = new RegisterReferralRequest();
    request.referrerCompanyId = companyId;
    request.insurerId = this.company.insurerId;
    request.firstName = this.firstName;
    request.lastName = this.lastName;
    request.email = this.email;
    request.phone = this.mobilePresence.length > 1 ? this.mobilePresence : this.phone;
    request.languageId = this.languageId;
    return request;
  }

  toIncompleteAlertRequest(referrerCompanyId: number, flow: string) {
    const request = new IncompleteAlertRequest();
    request.companyType = 1;
    request.insurerId = this.company?.insurerId;
    request.companyName = this.company?.name;
    request.countryId = this.company?.countryId;
    request.postalCode = this.company?.zipCode;
    request.city = this.company?.city;
    request.phone = this.company?.phone;
    request.vatNumber = this.company?.vatNumber;
    request.referrerCompanyId = referrerCompanyId;
    
    request.firstName = this.firstName;
    request.lastName = this.lastName;
    request.email = this.email;
    request.mobile = this.mobilePresence?.length > 1 ? this.mobilePresence : this.mobile;
    request.languageId = this.languageId;
    request.functionName = this.functionName;
    
    request.requestFlow = flow;
    
    return request;
  }
}
